module.exports = __webpack_public_path__ + "img/qr_watch_100.9af7b34e.png";